import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('loggedIn') === 'true');
    const [userDetails, setUserDetails] = useState({
        firstName: localStorage.getItem('firstName') || '',
        lastName: localStorage.getItem('lastName') || '',
        email: localStorage.getItem('email') || '' // Add email to the userDetails state
    });

    useEffect(() => {
        const loggedIn = localStorage.getItem('loggedIn') === 'true';
        if (loggedIn) {
            const firstName = localStorage.getItem('firstName');
            const lastName = localStorage.getItem('lastName');
            const email = localStorage.getItem('email'); // Retrieve email from localStorage
            setUserDetails({ firstName, lastName, email });
        }
    }, []);

    const login = (firstName, lastName, email) => {
        setIsLoggedIn(true);
        localStorage.setItem('loggedIn', 'true');
        localStorage.setItem('firstName', firstName);
        localStorage.setItem('lastName', lastName);
        localStorage.setItem('email', email); // Store userId in localStorage
        setUserDetails({ firstName, lastName, email });
    };

    const logout = () => {
        setIsLoggedIn(false);
        setUserDetails({ firstName: '', lastName: '', email: '' });
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('email'); // Remove userId from localStorage
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, userDetails, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
